/**
 * Pre-auth device identity (DEC-01). A random UUID is stored in
 * localStorage and used as the owner key for decisions until v1 auth lands
 * (AUTH-01) — at which point a one-time migration prompt claims device-keyed
 * rows under the newly signed-in user.
 */

const KEY = "academ.deviceId";

function uuid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `dev-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}

export function getDeviceId(): string {
  if (typeof window === "undefined") return "server";
  const existing = window.localStorage.getItem(KEY);
  if (existing) return existing;
  const fresh = uuid();
  window.localStorage.setItem(KEY, fresh);
  return fresh;
}
